const addInterceptors = httpInstance => {
    httpInstance.interceptors.request.use(request => {
        return request;
    });

    httpInstance.interceptors.response.use(
        response => {
            const { data: { data } } = response;
            return {
                data,
                error: null,
            };
        },
        async error => {
            if (error.response && httpInstance.store) {
                switch (error.response.status) {
                    case 412:
                        break;
                    case 503:
                    case 400:
                        return {
                            data: null,
                            error: error.response,
                        };

                    default:
                        return Promise.reject(error);
                }
            }

            return Promise.reject(error);
        }
    );

    return httpInstance;
};

export default addInterceptors;
